/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates how to break lines of text for a cell.
 */
export var TextCellLineBreakMode = /*@__PURE__*/ (function (TextCellLineBreakMode) {
    /**
     * Truncates the text content at the end and displays an ellipsis character if it can't fit on a line.
     */
    TextCellLineBreakMode[TextCellLineBreakMode["Ellipsis"] = 0] = "Ellipsis";
    /**
     * Keeps the text on a single line, but does not attempt to insert an ellipsis character.
     */
    TextCellLineBreakMode[TextCellLineBreakMode["NoWrap"] = 1] = "NoWrap";
    /**
     * If possible for the current platform, wraps to a new line on a word break, if necessary.
     */
    TextCellLineBreakMode[TextCellLineBreakMode["WordWrap"] = 2] = "WordWrap";
    /**
     * If possible for the current platform, wraps to a new line whenever necessary.
     */
    TextCellLineBreakMode[TextCellLineBreakMode["CharacterWrap"] = 3] = "CharacterWrap";
    return TextCellLineBreakMode;
})({});
/**
 * @hidden
 */
export var TextCellLineBreakMode_$type = /*@__PURE__*/ markEnum('TextCellLineBreakMode', 'Ellipsis,0|NoWrap,1|WordWrap,2|CharacterWrap,3');
//# sourceMappingURL=TextCellLineBreakMode.js.map
